<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
        <transition v-for="(item, key) of this.message" :key="item.id" name="fade">
          <b-container v-if="index == key">
            <b-row>
              <b-col xs="10" sm="8" md="5" class="t-icon">
                <img v-if="key == 0" :src="'static/img/tutorial/logo.png'">
                <img v-else-if="isLiteMode" :src="'static/img/tutorial/tutorial_'+ (key + 1) +'.png'">
                <img v-else :src="'static/img/tutorial/tutorial_'+ key +'.png'">
              </b-col>
              <b-col xs="10" sm="12" md="6" offset-md="1" class="t-box">
                <h2>
                  <img v-if="key != 0 && isLiteMode" :src="'static/img/tutorial/asset/tutorial_'+ (key + 1) +'.png'">
                  <img v-else-if="key != 0" :src="'static/img/tutorial/asset/tutorial_'+ key +'.png'">
                {{item.head}}
              </h2>
                <p>{{item.body}}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="10" sm="12">
                <img v-if="key == Object.keys(message).length - 1" @click="onClickClose" :src="'static/img/tutorial/' + checkLanguage + '/btn/tutorial_btn1.png'" class="next-btn">
                <img v-else @click="index = key + 1" :src="'static/img/tutorial/' + checkLanguage + '/btn/tutorial_btn2.png'" class="next-btn">
              </b-col>
            </b-row>
          </b-container>
        </transition>

        <!-- <transition name="fade" mode="out-in">
          <b-container v-if="index == 1">
            <b-row>
              <b-col xs="10" sm="8" md="5" class="t-icon">
                <img :src="'static/img/tutorial/okr.png'">
              </b-col>
              <b-col xs="10" sm="12" md="6" offset-md="1" class="t-box">
                <template v-if="this.checkLanguage === 'ja'">
                  <h2><img :src="'static/img/assets/nav_okr_on.png'" alt="">OKR</h2>
                  <p>あなたのObjectiveとKeyResultの内容や進捗状況などの目標を組織のメンバーと共有します。<br>
                  あなたの目標と他のメンバーの目標とを関連づけることができます。また、他のメンバーとOKRについてコメントを交換することができます。</p>
                </template>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="10" sm="12">
                <img @click="index = 2" :src="'static/img/tutorial/' + this.checkLanguage + '/btn/tutorial_btn2.png'" class="next-btn">
              </b-col>
            </b-row>
          </b-container> -->

        <!-- <transition name="fade">
          <b-container v-if="index == 0">
            <b-row>
              <b-col xs="10" sm="8" md="4" class="t-icon">
                <img :src="'static/img/tutorial/logo.png'">
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="10" sm="12" md="8" class="t-box">
                <template v-if="this.checkLanguage === 'ja'">
                  <h2 class="text-center">はじめまして</h2>
                  <p>1on1naviは、あなたの職場でのパフォーマンス向上を支援し、チームや組織全体のパフォーマンスを高める「パフォーマンスマネジメント」のためのツールです。</p>
                  <h2 class="text-center">{{$t('tutorial[0].head')}}</h2>
                  <p>{{$t('tutorial[0].body')}}</p>
                </template>
                <template v-else-if="this.checkLanguage === 'en'">
                  <h2 class="text-center">Hello!</h2>
                  <p>1on1navi is an application tool for "performance management" that supports performance improvement in your workplace.</p>
                </template>
                <template v-else-if="this.checkLanguage === 'zh_tr'">
                  <h2 class="text-center">你好 !</h2>
                  <p>1on1navi是一款支持提高妳的職場表現並且能夠幫助提高團隊的整體表現的
                    【績效管理】軟件。</p>
                </template>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="10" sm="12">
                <img @click="index = 1" :src="'static/img/tutorial/' + this.checkLanguage + '/btn/tutorial_btn2.png'" class="next-btn">
              </b-col>
            </b-row>
          </b-container>
        </transition>
        <transition name="fade" mode="out-in">
          <b-container v-if="index == 1">
            <b-row>
              <b-col xs="10" sm="8" md="5" class="t-icon">
                <img :src="'static/img/tutorial/okr.png'">
              </b-col>
              <b-col xs="10" sm="12" md="6" offset-md="1" class="t-box">
                <template v-if="this.checkLanguage === 'ja'">
                  <h2><img :src="'static/img/assets/nav_okr_on.png'" alt="">OKR</h2>
                  <p>あなたのObjectiveとKeyResultの内容や進捗状況などの目標を組織のメンバーと共有します。<br>
                  あなたの目標と他のメンバーの目標とを関連づけることができます。また、他のメンバーとOKRについてコメントを交換することができます。</p>
                </template>
                <template v-else-if="this.checkLanguage === 'en'">
                  <h2><img :src="'static/img/assets/nav_okr_on.png'" alt="">OKR</h2>
                  <p>Objectives, Key Results and their progress can be opened among your organization.
                    Your OKRs can be connected with other ones’ OKRs and you can exchange comments with other people.</p>
                </template>
                <template v-else-if="this.checkLanguage === 'zh_tr'">
                  <h2><img :src="'static/img/assets/nav_okr_on.png'" alt="">OKR</h2>
                  <p>妳的目標和關鍵成果的內容和狀況等
                    信息可以和組內成員共享。
                    自己的目標和其他成員的目標可以關聯在一起。而且，可以和其他成員就OKR話題進行互相評論和討論。</p>
                </template>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="10" sm="12">
                <img @click="index = 2" :src="'static/img/tutorial/' + this.checkLanguage + '/btn/tutorial_btn2.png'" class="next-btn">
              </b-col>
            </b-row>
          </b-container>
        </transition>
        <transition name="fade" mode="out-in">
          <b-container  v-if="index == 2">
            <b-row>
              <b-col xs="10" sm="8" md="5" class="t-icon">
                <img :src="'static/img/tutorial/1on1.png'">
              </b-col>
              <b-col xs="10" sm="12" md="6" offset-md="1" class="t-box">
                <template v-if="this.checkLanguage === 'ja'">
                  <h2><img :src="'static/img/assets/nav_1on1_on.png'" alt="">1on1</h2>
                  <p>1on1で得られたあなたの気づきなどを簡単に登録します。<br>
                  登録した内容を上司や他のメンバーに公開してコメントを交換することができます。あなたから上司へ1on1のリクエストを送ることもできます。</p>
                </template>
                <template v-else-if="this.checkLanguage === 'en'">
                  <h2><img :src="'static/img/assets/nav_1on1_on.png'" alt="">1on1</h2>
                  <p>You can easily record your insights from 1on1s.
                    Your insights can be opened among your organization, and you can exchange comments with others.
                    You can also send a 1on1 request to your supervisor.</p>
                </template>
                <template v-else-if="this.checkLanguage === 'zh_tr'">
                  <h2><img :src="'static/img/assets/nav_1on1_on.png'" alt="">1on1</h2>
                  <p>可以簡單的記錄登陸從1on1中得到的
                    注意點。
                    自己記錄的內容可以和領導
                    或者組內成員共享並且可以互相評論。
                    妳也可以嚮妳的上司髪/発送關于1on1的要求。</p>
                </template>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="10" sm="12">
                <img @click="index = 3" :src="'static/img/tutorial/' + this.checkLanguage + '/btn/tutorial_btn2.png'" class="next-btn">
              </b-col>
            </b-row>
          </b-container>
        </transition>
        <transition name="fade" mode="out-in">
          <b-container  v-if="index == 3">
            <b-row>
              <b-col xs="10" sm="10" md="5" class="t-icon">
                <img :src="'static/img/tutorial/fb.png'">
              </b-col>
              <b-col xs="10" sm="12" md="6" offset-md="1" class="t-box">
                <template v-if="this.checkLanguage === 'ja'">
                  <h2><img :src="'static/img/assets/nav_rtfb_on.png'" alt="">FB Request</h2>
                  <p>1on1以外の場でも組織の中のさまざまなメンバーから、いつでもフィードバンクをもらうことができます。<br>
                  例えば、自分のプレゼンテーションに対する他者からのフィードバックコメントや、よくできたことへの承認(いいね)をリクエストできます。</p>
                </template>
                <template v-else-if="this.checkLanguage === 'en'">
                  <h2><img :src="'static/img/assets/nav_rtfb_on.png'" alt="">FB Request</h2>
                  <p>You can get feedback any time, from any person in your organization, by requesting feedback, for example, on your presentation, or requesting recognition on your good job.</p>
                </template>
                <template v-else-if="this.checkLanguage === 'zh_tr'">
                  <h2><img :src="'static/img/assets/nav_rtfb_on.png'" alt="">FB Request</h2>
                  <p>1on1之外的情況下，
                    也可以隨時的從組內的任何一箇/個
                    成員中得到及時的反馈。
                    比如，可以及時的從別的組員那裏得到關于自己的演示的反馈和評論，
                    做的很好的部分也可以得到點贊，
                    也可以提要求。</p>
                </template>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="10" sm="12">
                <img @click="onClickClose" :src="'static/img/tutorial/' + this.checkLanguage + '/btn/tutorial_btn1.png'" class="next-btn">
              </b-col>
            </b-row>
          </b-container>
        </transition> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { i18n, settings, liteMode } from '@/main.js'

export default {
  name: 'Tutorial',
  data: function () {
    return {
      index: 0,
      message: settings.i18n[i18n.locale].tutorial,
      locale: i18n.locale,
      isLiteMode: liteMode
    }
  },
  computed: {
    checkLanguage () {
      if (!i18n) {
        return 'ja'
      } else {
        return i18n.locale
      }
    }
  },
  mounted: function () {
    console.log('i18n.message', i18n.locale)
    if (liteMode) {
      this.message.splice(1, 1)
    }
  },
  methods: {
    onClickClose: function () {
      this.$emit('end-tutorial')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 15%;
  margin: 0 auto;
}
@media (min-width: 768px){
  bottom: 30%;
}
.modal-mask{
  background-color: #2c9ff7;
}
.modal-wrapper {
  position: relative;
  /* top: -2em; */
}
.t-icon{
  display: block;
  /* width: 20vw; */
  height: auto;
  margin: 0 auto;
}
.t-box {
  color: #fff;
  margin: 0 auto;
}
.t-box h2{
  margin: 3vw 0 2vw;
  font-size: 2em;
  font-weight: bold;
}
.t-box h2 img{
  width: 1em;
  display: inline-block;
  margin-right: 0.5em;
}
.t-box p { font-size: 1.3em; }
.t-icon img{ width: 100%; }
.tutorial-container {
  width: 80vw;
  margin: 0 auto;
}
.tutorial-img {
  display: block;
  height: 80vh;
  margin: 0 auto;
}
.next-btn {
  cursor: pointer;
  display: block;
  /* width: 20em; */
  height: 4em;
  margin: 1.5em auto 0;
  transition: 0.2s all ease;
}
.next-btn:hover {
  /* width: 21em; */
  height: 4.5em;
  margin: 1em auto 0;
}
.fade-enter-active, .fade-leave-active,
.modal-enter-active, .modal-leave-active {
  transition: all 1s ease-in-out ;
}
.fade-enter, .fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.modal-enter, .modal-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Tutorial.vue